import React from "react";
import MapView from "./MapView";
import { useReceiptCardInfo } from "./handler/useReceiptCardInfo";
import { IRightCardProps } from "./types";
import { IReceiptDriver } from "../../models/receipt/receipt";

const RightCard: React.FC<IRightCardProps> = ({
  data,
  orderStatus,
  className,
}) => {
  const { pickup, dropoff, driverObj, encodedPolyline } = useReceiptCardInfo(
    orderStatus,
    data,
  );

  const HongKongDefaultLocation = {
    lat: 22.3193,
    lng: 114.1694,
  };

  return (
    <div className={`flex-1 h-full flex items-stretch ${className}`}>
      <div className="w-full h-full">
        <MapView
          start={{
            lat: pickup?.lat || HongKongDefaultLocation.lat,
            lng: pickup?.lng || HongKongDefaultLocation.lng,
          }}
          end={{
            lat: dropoff?.lat || HongKongDefaultLocation.lat,
            lng: dropoff?.lng || HongKongDefaultLocation.lng,
          }}
          zoom={14}
          apiKey={process.env.REACT_APP_GOOGLE_MAP_API_KEY || ""}
          encodedPolyline={encodedPolyline}
          status={orderStatus}
          driverHeartbeat={data?.driver?.heartBeat || { lat: 0, lng: 0 }}
          driver={driverObj || ({} as IReceiptDriver)}
        />
      </div>
    </div>
  );
};

export default RightCard;
